import { Tab as MuiTab, TabProps, Tabs } from '@mui/material';
import * as React from 'react';
import { ListPageWrapper, TabLabel } from '../../shared';
import { Link, LinkProps, Outlet, useLocation } from 'react-router-dom';
import { getRoute } from '../../app/router';
import { keycloak, KeycloakRoles } from '@coverright/shared/keycloak';

export const RoundRobin = () => {
  const location = useLocation();
  const tab = location.pathname.split('/').at(2);
  const mainTab = tab || 'agents';
  const isTechManager = keycloak?.hasRealmRole(KeycloakRoles.ROLE_TECH_STAFF)

  return (
    <ListPageWrapper>
      <Tabs value={mainTab} sx={{flex: 1, mb: 2, minHeight: 35}}>
        <Tab to={`/${getRoute(`roundRobin`)}/agents`} value={'agents'} label={<TabLabel>Agents</TabLabel>} />
        {isTechManager && <Tab to={`/${getRoute(`roundRobin`)}/state`} value={'state'} label={<TabLabel>State</TabLabel>} />}
        <Tab to={`/${getRoute(`roundRobin`)}/tasks`} value={'tasks'} label={<TabLabel>Tasks</TabLabel>} />
      </Tabs>

      <Outlet />
    </ListPageWrapper>
  );
}

const Tab = (props: TabProps & LinkProps) => (
  <MuiTab component={Link} iconPosition={'start'} {...props} />
)
